import { execOnLoad } from '@general/helpers';
import { closeModal, initModals } from '@components/modals';
import { initProductForm } from '@components/product';
import { openMinicart } from '@components/minicart';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initQuickBuy = (context) => {
  const snippetContainer = context.classList.contains('.quick-buy__container')
    ? context
    : context.closest('.quick-buy__container');
  if (
    !snippetContainer ||
    snippetContainer.classList.contains('quick-buy__container--initialized')
  )
    return;

  const quickBuyModal = snippetContainer.querySelector('.quick-buy__modal');
  if (!quickBuyModal) return;
  initModals(snippetContainer);
  document.body.appendChild(quickBuyModal);

  const form = quickBuyModal.querySelector('.quick-buy__form');
  if (form) {
    const errorWrapper = form.querySelector('.quick-buy__error-wrapper');
    const errorMessage = form.querySelector('.quick-buy__error [data-message]');

    const updateOptions = ({ variant: selectedVariant, product }) => {
      const options = selectedVariant.options.reduce(
        (acc, option, index) => ({
          ...acc,
          [`option${index + 1}`]: option,
        }),
        {},
      );

      quickBuyModal
        .querySelectorAll('.quick-buy__option-value input')
        .forEach((input) => {
          const currentOptions = {
            ...options,
            [input.name]: input.value,
          };
          const foundVariant = product.variants.find((variant) =>
            Object.keys(currentOptions).every(
              (optionName) => variant[optionName] == currentOptions[optionName],
            ),
          );
          input.disabled =
            !input.checked && foundVariant && !foundVariant?.available;
        });
    };

    initProductForm({
      form,
      callbacks: {
        afterVariantChange: async ({ variant, product }) => {
          variant.options.forEach((option, index) => {
            const label = quickBuyModal.querySelector(
              `label[for="option${index + 1}"] [data-current-value]`,
            );
            if (label) label.innerText = option;
          });
          errorWrapper.classList.remove('shown');

          updateOptions({ variant, product });
        },
        beforeSubmit: () => {
          if (quickBuyModal) quickBuyModal.classList.add('loading');
        },
        afterSubmit: async () => {
          await closeModal(quickBuyModal);
          await openMinicart(true);
          if (quickBuyModal) quickBuyModal.classList.remove('loading');
        },
        errorCallback: (err) => {
          if (quickBuyModal) quickBuyModal.classList.remove('loading');
          if (errorWrapper && errorMessage && err?.data?.message) {
            errorMessage.innerText = err.data.message;
            requestAnimationFrame(() => {
              errorWrapper.classList.add('shown');
              setTimeout(() => {
                errorWrapper.classList.remove('shown');
              }, 3000);
            });
          }
        },
      },
    });
  }

  const gallery = quickBuyModal.querySelector('.quick-buy__gallery-wrapper');
  if (gallery) {
    const icons = window?.dAgency?.icons;
    const lightbox = new PhotoSwipeLightbox({
      gallery: gallery,
      children: '.quick-buy__gallery-slide--image',
      pswpModule: PhotoSwipe,
      mainClass: 'pswp--custom',
      arrowPrev: true,
      arrowNext: true,
      zoom: false,
      close: true,
      counter: false,
      bgOpacity: 0.8,
      showHideAnimationType: 'fade',
      ...(icons
        ? {
            ...(icons.chevronLeft && icons.chevronRight
              ? {
                  arrowPrevSVG: icons.chevronLeft,
                  arrowNextSVG: icons.chevronRight,
                }
              : {}),
            ...(icons.close ? { closeSVG: icons.close } : {}),
          }
        : {}),
    });
    lightbox.on('uiRegister', function () {
      lightbox.pswp.ui.registerElement({
        name: 'bulletsIndicator',
        className: 'pswp__bullets-indicator',
        appendTo: 'wrapper',
        onInit: (el, pswp) => {
          const bullets = [];
          let bullet;
          let prevIndex = -1;

          for (let i = 0; i < pswp.getNumItems(); i++) {
            bullet = document.createElement('div');
            bullet.className = 'pswp__bullet';
            bullet.onclick = (e) => {
              pswp.goTo(bullets.indexOf(e.target));
            };
            el.appendChild(bullet);
            bullets.push(bullet);
          }

          pswp.on('change', () => {
            if (prevIndex >= 0) {
              bullets[prevIndex].classList.remove('pswp__bullet--active');
            }
            bullets[pswp.currIndex].classList.add('pswp__bullet--active');
            prevIndex = pswp.currIndex;
          });
        },
      });
    });
    lightbox.init();
  }

  snippetContainer.classList.add('quick-buy__container--initialized');
};

execOnLoad(window.dAgency.initQuickBuy, '.quick-buy__container');
